import { Common } from "@common/types";
import classNames from "classnames";
import React from "react";
import { IconAction, type IconActionSize } from "../component";

export type HelpIconProps = {
  className?: string;
  tooltip: string;
  name?: string;
  size?: IconActionSize;
};
const HelpIcon = (props: HelpIconProps) => (
  <IconAction
    className={classNames("help", props.className)}
    icon={Common.IconType.QuestionCircle}
    data-name={props.name}
    size={props.size ?? 16}
    tooltip={props.tooltip}
  />
);
export default HelpIcon;
